import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-left" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "navbar-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "mr-2",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M13.228 5.53267L9.228 2.42133C8.506 1.85933 7.49467 1.85933 6.772 2.42133L2.772 5.53267C2.28467 5.91133 2 6.494 2 7.11133V12C2 13.1047 2.89533 14 4 14H12C13.1047 14 14 13.1047 14 12V7.11133C14 6.494 13.7153 5.91133 13.228 5.53267Z",
          stroke: "#1E293B",
          "stroke-width": "1.5"
        }),
        _createElementVNode("path", {
          d: "M6 11.3333H10",
          stroke: "#1E293B",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      _createElementVNode("p", null, [
        _cache[1] || (_cache[1] = _createTextVNode(" / Users ")),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.breadcrumbName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage()))
      }, _toDisplayString(_ctx.buttonTitle), 1)
    ])
  ]))
}